import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import "./styles/editorial.css";
import "./App.css";
import { TopNav, Footer, VerticalStamp } from "./components/editorial/Layout";
import Home from "./components/home/home";
import AboutDetails from "./components/about/aboutDetails";
import ServicesDetails from "./components/services/servicesDetails";
import PortofolioPage from "./components/galery/portofolioPage";
import House from "./components/galery/house";
import JournalPage from "./components/journal/JournalPage";
import ContactPage from "./components/contact/contactPage";
import SmoothScroll from "./components/home/smooth-scroll";

library.add(fas);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <TopNav />
        <VerticalStamp />
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutDetails />} />
            <Route path="/services" element={<ServicesDetails />} />
            <Route path="/portofolio" element={<PortofolioPage />} />
            <Route path="/portofolio/:topicId" element={<House />} />
            <Route path="/journal" element={<JournalPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </SmoothScroll>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
